import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import { _Config, _IsUserPremiumFromPartners, _user, } from "@discovery/common-dplus/lib/state";
import { Fold } from "@discovery/prelude/lib/control/lens";
import * as M from "@discovery/prelude/lib/data/maybe";
import { _ColAttributes2Alias, _ColAttributes2Title, } from "@discovery/sonic-api-ng-optics";
import { TabList } from "./optics";
import { useUser } from "../../utils/hooks";
import { navigateTo } from "../../utils/common";
import { useEffect } from "@discovery/common-dplus/lib/hooks";
import { setAuthRedirectUrl } from "../../utils/authUrl";
const LikedVideosView = React.lazy(() => import("./favouritesView"));
const WatchLaterView = React.lazy(() => import("./watchLaterView"));
let FavoritesTabs = [];
let WatchLaterTabs = [];
export var VideoType;
(function (VideoType) {
    VideoType["SHOWS"] = "SHOWS";
    VideoType["EPISODES"] = "EPISODE";
    VideoType["SHORTS"] = "CLIP";
})(VideoType || (VideoType = {}));
export var Playlist;
(function (Playlist) {
    Playlist["EPISODES"] = "dplus-watchlist-videos";
    Playlist["SHORTS"] = "dplus-watchlist-shorts";
})(Playlist || (Playlist = {}));
const getProps = (data) => {
    const titleM = Fold.preview(Fold.compose(_ColAttributes2Title, M._Just()), data);
    const Col2AliasM = Fold.preview(_ColAttributes2Alias, data);
    const Col2Alias = M.fromMaybe(Col2AliasM, "");
    const tabList = Fold.toArray(TabList, data);
    return {
        titleM,
        tabList,
        Col2Alias,
    };
};
const LikedVideos = ({ titleM, tabList, Col2Alias, environment, }) => {
    const [configM] = useGlobalState(_Config);
    const [userM] = useGlobalState(_user);
    const { isAnonymous, premiumPackagesM } = useUser();
    const webAuthUrl = environment.authService.protocol + "://" + environment.authService.domain;
    const authUrl = webAuthUrl + "/login";
    const [isPremiumUserFromPartner] = useGlobalState(_IsUserPremiumFromPartners);
    // CONFIG
    const featureTogglesM = M.chain((x) => x.featureToggles, configM);
    const premiumPackages = M.fromMaybe(premiumPackagesM, [""]);
    const parentalLockM = M.chain((x) => x.parentalLock, configM);
    const minimumAgeM = M.chain((x) => x.minimumAge, parentalLockM);
    const ageConstraint = M.fromMaybe(minimumAgeM, 0);
    const enableAdsM = M.chain((x) => x.enableAds, featureTogglesM);
    const adsM = M.chain((x) => x.ads, configM);
    const vastTagM = M.chain((x) => x.vastTag, adsM);
    const shortvastTagM = M.chain((x) => x.shortsVastTag, adsM);
    const imaAdsConfig = {
        vastTag: M.fromMaybe(vastTagM, ""),
        shortsVastTag: M.fromMaybe(shortvastTagM, ""),
        enableAds: isPremiumUserFromPartner
            ? false
            : M.fromMaybe(enableAdsM, false),
    };
    const authRedirect = isAnonymous && setAuthRedirectUrl(window.location.pathname);
    const userDetails = {
        idM: M.map((user) => user.id, userM),
    };
    const userId = M.fromMaybe(userDetails.idM, "");
    useEffect(() => {
        return () => {
            FavoritesTabs = [];
            WatchLaterTabs = [];
        };
    }, []);
    tabList.map((item) => {
        if (Col2Alias === "favorites-tab-menu") {
            switch (item) {
                case "favorited-shows-tab-bar":
                    FavoritesTabs.push({
                        title: "Shows",
                        id: VideoType.SHOWS,
                    });
                    break;
                case "favorited-shorts-tab-bar":
                    FavoritesTabs.push({
                        title: "Shorts",
                        id: VideoType.SHORTS,
                    });
                    break;
                case "favorited-episodes-tab-bar":
                    FavoritesTabs.push({
                        title: "Episodes",
                        id: VideoType.EPISODES,
                    });
                    break;
            }
        }
        else {
            switch (item) {
                case "watch-later-episodes-tab":
                    WatchLaterTabs.push({
                        title: "Episodes",
                        id: Playlist.EPISODES,
                    });
                    break;
                case "watch-later-shorts-tab":
                    WatchLaterTabs.push({
                        title: "Shorts",
                        id: Playlist.SHORTS,
                    });
                    break;
                case "watch-later-shows-tab":
                    WatchLaterTabs.push({
                        title: "Shows",
                        id: Playlist.SHORTS,
                    });
                    break;
            }
        }
    });
    return (React.createElement(React.Fragment, null, isAnonymous ? (navigateTo(`${authUrl}?returnUrl=${authRedirect}`)) : (React.createElement(React.Suspense, { fallback: () => React.createElement(React.Fragment, null) }, Col2Alias === "favorites-tab-menu" ? (React.createElement(LikedVideosView, { read: environment, headerTitleM: titleM, premiumPackages: premiumPackages, ageConstraint: ageConstraint, imaAdsConfig: imaAdsConfig, FavoritesTabs: FavoritesTabs, userId: userId })) : (React.createElement(WatchLaterView, { read: environment, headerTitleM: titleM, premiumPackages: premiumPackages, ageConstraint: ageConstraint, imaAdsConfig: imaAdsConfig, WatchLaterTabs: WatchLaterTabs }))))));
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, LikedVideos);

